import { Domain, SslCertificate } from "@/types/domain";
import { NotificationGroup } from "@/types/notification";
import { AxiosResponse } from "axios";

export function toDomain(apiResponse: any): Domain | undefined {
	let domain: Domain;
	if (apiResponse != null) {
		domain = {
			hostname: apiResponse["hostname"],
			ipAddress: apiResponse["ipAddress"],
			id: apiResponse["_id"],
			sslCertificates: toSslCertificates(apiResponse["sslCertificates"]),
			disabled: apiResponse["disabled"],
			disabledOn: apiResponse["disabledOn"],
		};
		return domain;
	}
}

export function toSslCertificates(apiResponse: any): SslCertificate[] {
	let sslCertificates: SslCertificate[] = [];

	if (apiResponse != null) {
		apiResponse.forEach((certificate: any) => {
			let sslCertificate: SslCertificate = {
				expires: certificate["validTo"],
				issuedBy: certificate["issuedBy"],
				activeSince: certificate["validFrom"],
				fingerprint: certificate["fingerprint"],
				fingerprint256: certificate["fingerprint256"],
				subjectAltNames: certificate["subjectAltNames"],
				errors: certificate["errors"],
			};

			sslCertificates.push(sslCertificate);
		});
	}
	return sslCertificates;
}

export function toNotificationGroup(apiResponse: AxiosResponse<any>): NotificationGroup {
	let notificationGroup: NotificationGroup;
	if (apiResponse.data) {
		notificationGroup = {
			createdOn: apiResponse.data.createdOn,
			domainIdsToBeNotifiedAbout: apiResponse.data.domainIdsToBeNotifiedAbout,
			eventsToBeNotifiedAbout: apiResponse.data.eventsToBeNotifiedAbout,
			recipientEmailAddresses: apiResponse.data.recipientEmailAddresses,
			groupName: apiResponse.data.groupName,
			id: apiResponse.data.id,
		};
		return notificationGroup;
	} else {
		notificationGroup = {
			domainIdsToBeNotifiedAbout: [],
			eventsToBeNotifiedAbout: [],
			recipientEmailAddresses: [],
		};

		return notificationGroup;
	}
}
